<div class="container">
    <div class="loghi-istituzionali">
        <p>Intervento finanziato nell'ambito del PSR Puglia 2014/2020 - GAL MAGNA GRECIA scral - Misura 19 - Sottomisura 19.2 - Azione 1 - Intervento 1.2 "Avviamento start-up innovative"</p>
        <img src="assets/img/UE.jpg" alt="Unione Europea"/>
        <img src="assets/img/RepubblicaItaliana.png" alt="Repubblica Italiana"/>
        <img src="assets/img/RegionePuglia.png" alt="Regione Puglia"/>
        <img src="assets/img/PSR.png" alt="PSR"/>
        <img src="assets/img/Leader.png" alt="Leader"/>
        <img src="assets/img/GAL.png" alt="GAL"/>
    </div>

</div>